const initState = {
  apps: [],
  app: {},
  customers: [],
  statistics: {},
  chartData: {},
  loading: true,
  error: false,
}

const reducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_APPS':
      return {...state, apps: action.payload}
    case 'SET_APP': 
      return {...state, app: action.payload}
    case 'SET_CUSTOMERS':
      return {...state, customers: action.payload}
    case 'SET_STATS':
      return {...state, statistics: action.payload}
    case 'SET_CHART_DATA':
      return {...state, chartData: action.payload}
    case 'SET_LOADING': 
      return {...state, loading: action.payload}
    case 'SET_ERROR':
      return {...state, error: action.payload}
    default: 
      return state
  }
}

export default reducer